/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusIndividuelleAnforderungStandortDto } from '../../models/lexplus-individuelle-anforderung-standort-dto';
import { LexplusUpdateAllAnforderungErfuellungsgradDto } from '../../models/lexplus-update-all-anforderung-erfuellungsgrad-dto';

export interface IndividuelleAnforderungDetailControllerUpdateIndividuelleAnforderungErfuellungsgradForAllStandorteV1$Params {
  individuelleAnforderungID: string;
      body: LexplusUpdateAllAnforderungErfuellungsgradDto
}

export function individuelleAnforderungDetailControllerUpdateIndividuelleAnforderungErfuellungsgradForAllStandorteV1(http: HttpClient, rootUrl: string, params: IndividuelleAnforderungDetailControllerUpdateIndividuelleAnforderungErfuellungsgradForAllStandorteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusIndividuelleAnforderungStandortDto>>> {
  const rb = new RequestBuilder(rootUrl, individuelleAnforderungDetailControllerUpdateIndividuelleAnforderungErfuellungsgradForAllStandorteV1.PATH, 'patch');
  if (params) {
    rb.path('individuelleAnforderungID', params.individuelleAnforderungID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusIndividuelleAnforderungStandortDto>>;
    })
  );
}

individuelleAnforderungDetailControllerUpdateIndividuelleAnforderungErfuellungsgradForAllStandorteV1.PATH = '/v1/compliance/firmeninterne-anforderungen/{individuelleAnforderungID}/erfuellungsgrad';
